import { fill } from 'lodash';
import Ghost from 'react-loading-skeleton';

import { Layout, LayoutProps } from '../Layout';

export type SkeletonProps = { circle?: boolean; layout?: Partial<LayoutProps> };

const RandomLine: React.FC = () => (
	<Ghost
		className="d-block"
		style={{ marginBottom: 1 }}
		width={50 + Math.floor(Math.random() * 20)}
		height={13.5}
	/>
);

export const Skeleton: React.FC<SkeletonProps> = ({ circle, ...props }) => (
	<Layout
		address={
			<div>
				{fill(Array(3), null).map((_, key) => (
					<RandomLine key={key} />
				))}
			</div>
		}
		currentHours={<Ghost width={100} className="d-block" />}
		distance={<Ghost width={50} height={20} className="d-block" />}
		hoursWarning={<Ghost width={120} className="d-block mt-1" />}
		name={
			<Ghost
				width={100}
				height={16}
				style={{ marginBottom: 4 }}
				className="d-block"
			/>
		}
		{...props.layout}
		className={`store-list-item-skeleton${
			props.layout?.className ? ` ${props.layout.className}` : ''
		}`}
	>
		<Ghost
			width={circle ? 40 : 80}
			height={circle ? 40 : 30}
			circle={circle}
		/>
	</Layout>
);
